<template>
  <div class="novelty-search-container">
    <!-- 内容区域 -->
    <div class="content-section">
      <div class="container">
        <!-- 查新服务 -->
        <div class="content-item">
          <img src="../../assets/image/searchbg.png" alt="">
          <div class="u-p-30">
            <h3 class="content-title">{{ info.title }}</h3>
            <div class="content-text" v-html="info.value"></div>
            <div class="u-h-60"></div>
            <!-- <h3 class="content-title">中心简介</h3>
            <p class="content-text">
              我中心依托国家一级查新单位，围绕科研立项、成果鉴定、专利申请、高新技术企业认定与复审、科技奖励等创新需求长期开展科技查新咨询服务工作。 国家一级查新单位是经科技部认定的，
              具备科技查新资质，并严格按照科技查新规范进行操作的机构,机构人才队伍专业知识扎实，检索经验丰富， 综合分析能力过硬。
            </p>
            <div class="u-h-60"></div>
            <h3 class="content-title">查新工作时效</h3>
            <p class="content-text">
              1. 国内科技查新报告完成时间为<span class="cl_F66F00">5个工作日</span>；国内外科技查新报告完成时间为<span class="cl_F66F00">8个工作日</span>，以上时间均从收到可以受理的委托单并付费之后的第二个工作日开始计算；<br>
              2. 科技查新报告可以办理加急，国内科技查新最多加急至<span class="cl_F66F00">2个工作日</span>完成；国内外科技查新报告最多加急至<span class="cl_F66F00">4个工作日</span>完成。
            </p> -->
          </div>
        </div>
        <!-- 底部链接 -->
        <div class="bottom-links">
              <div class="u-flex u-gap-6 u-m-r-30">
                <img src="../../assets/image/file.png" alt="">
                <div class="download-file">
                  <span class="file-name">{{info2.title}}</span>
                  <!-- <span class="file-size">7.7KB</span> -->
                </div>
              </div>
              <button class="download-btn" @click="downlaod(info2.value)"><i class="el-icon-download"></i> 点击下载查新表</button>
        </div>
      </div>
    </div>
    <!-- 查新的作用-科技查新流程 -->
    <div class="report-function-section">
      <div class="container">
        <!-- 查新的作用 -->
        <div class="report-function-header">
          <div class="report-title">查新的作用<span style="color: #F66F00;text-align: center !important;">•</span></div>
          <div class="news-subtitle">（让您查新的目的更清晰）</div>
        </div>
        <div class="report-function-grid">
          <div class="function-item">
            <div class="function-icon">
              <img src="../../assets/image/search-icon1.png" alt="">
            </div>
            <div class="function-title">科研项目开题立项</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img src="../../assets/image/search-icon2.png" alt="">
            </div>
            <div class="function-title">科研成果评价（鉴定）</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img src="../../assets/image/search-icon3.png" alt="">
            </div>
            <div class="function-title">申报科技奖励</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img src="../../assets/image/search-icon4.png" alt="">
            </div>
            <div class="function-title">技术研究/开发</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img src="../../assets/image/search-icon5.png" alt="">
            </div>
            <div class="function-title">申请知识产权</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img src="../../assets/image/search-icon6.png" alt="">
            </div>
            <div class="function-title">科技项目验收</div>
          </div>
        </div>

        <!-- 科技查新流程 -->
        <div class="workflow-header">
          <div class="report-title">科技查新流程<span style="color: #F66F00;text-align: center !important;">•</span></div>
          <div class="news-subtitle">TECHNOLOGY SEARCH PROCESS</div>
        </div>
        <div class="workflow-steps">
          <div class="workflow-step">
            <div class="step-icon">
              <img src="../../assets/image/step1.png" alt="Step 01">
            </div>
            <div class="step-number">Step 01</div>
            <div class="step-title">查新材料审查</div>
          </div>
          <div class="workflow-step">
            <div class="step-icon">
              <img src="../../assets/image/step2.png" alt="Step 02">
            </div>
            <div class="step-number">Step 02</div>
            <div class="step-title">签订查新委托协议</div>
          </div>
          <div class="workflow-step">
            <div class="step-icon">
              <img src="../../assets/image/step33.png" alt="Step 03">
            </div>
            <div class="step-number">Step 03</div>
            <div class="step-title">支付查新费用</div>
          </div>
          <div class="workflow-step">
            <div class="step-icon">
              <img src="../../assets/image/step44.png" alt="Step 04">
            </div>
            <div class="step-number">Step 04</div>
            <div class="step-title">开始查新检索</div>
          </div>
          <div class="workflow-step">
            <div class="step-icon">
              <img src="../../assets/image/step5.png" alt="Step 05">
            </div>
            <div class="step-number">Step 05</div>
            <div class="step-title">初始报告确认</div>
          </div>
          <div class="workflow-step">
            <div class="step-icon">
              <img src="../../assets/image/step6.png" alt="Step 06">
            </div>
            <div class="step-number">Step 06</div>
            <div class="step-title">出具正式查新报告</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { chaxinConfig } from '@/api/index.js'
import { httphosts } from '@/utils/global'

export default {
  name: 'NoveltySearch',
  data() {
    return {
      info: '',
      info2: ''
    }
  },
  mounted() {
    this.getChaxinConfig()
  },
  methods: {
    // 获取科技查新
    getChaxinConfig() {
      chaxinConfig().then(res => {
        if (res.code === 1) {
          this.info = res.data.tns_content
          this.info2 = res.data.tns_file
        }
      })
    },
    downlaod(item) {
      // 直接下载文件到本地
      const link = document.createElement('a')
      link.href = httphosts + item
      link.download = this.info2.title
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style scoped>
/* 页面容器 */
.novelty-search-container {
  width: 100%;
  min-height: 100vh;
}

/* 蓝色横幅 */
.banner-section {
  background: linear-gradient(135deg, #1B5AFF 0%, #0D47A1 100%);
  padding: 40px 0;
  color: white;
}

.banner-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.banner-text {
  flex: 1;
  padding-right: 40px;
}

.banner-text h3 {
  font-size: 18px;
  margin: 0 0 10px 0;
  color: #FFD700;
}

.banner-text h2 {
  font-size: 32px;
  margin: 0 0 10px 0;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.magnifier-icon {
  font-size: 24px;
  margin-left: 10px;
  color: #FFD700;
}

.banner-text p {
  font-size: 14px;
  margin: 0;
  opacity: 0.9;
}

.banner-image {
  flex: 0 0 300px;
}

.banner-image img {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

/* 内容区域 */
.content-section {
  padding: 40px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.content-item {
  margin-bottom: 40px;
  /* width: 1254px; */
  /* height: 458px; */
  background: #FFFFFF;
  box-shadow: 0px 3px 8px 1px rgba(60,97,135,0.05);
  border-radius: 8px;
}
.content-item img{
  width: 100%;
  height: auto;
  border-radius: 8px 8px 0 0;
}

.content-title {
  font-weight: 500;
  font-size: 20px;
  color: #1B5AFF;
  margin: 0 0 15px 0;
  /* border-bottom: 2px solid #1B5AFF; */
}

.content-text {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  margin: 0;
}

/* 底部链接 */
.bottom-links {
  background: #FFFFFF;
  box-shadow: 0px 3px 8px 1px rgba(60,97,135,0.05);
  border-radius: 8px 8px 8px 8px;
  padding: 30px 40px;
  display: flex;
  /* justify-content: space-between; */
  align-items: flex-end;
}

.download-file {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.file-name {
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-size {
  font-size: 12px;
  color: #999;
}

.download-btn {
  /* position: absolute; */
  /* bottom: 12px; */
  /* right: 12px; */
  /* padding: 6px 12px; */
  background-color: transparent;
  color: #0066cc;
  border: none;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.download-btn:hover {
  /* background-color: #0052a3; */
  color: #F66F00;
}

/* 评价报告与作用部分样式 */
.report-title {
  font-size: 30px;
  color: #1B5AFF;
  margin-bottom: 0;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
}
.news-subtitle {
  font-size: 20px;
  color: #DDE4EA;
  /* margin-bottom: 30px; */
}
.report-function-section {
  padding: 60px 0;
  background: #fff;
}

.report-function-header,
.workflow-header {
  text-align: center;
  margin-bottom: 40px;
}

.report-function-header h2,
.workflow-header h2 {
  font-size: 28px;
  color: #333;
  margin-bottom: 10px;
  font-weight: bold;
}

.report-function-header p,
.workflow-header p {
  font-size: 16px;
  color: #1B5AFF;
  margin: 0;
}

/* 评价报告作用网格 */
.report-function-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  margin-bottom: 100px;
}

.function-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 30px 20px;
  /* background: #f9f9f9; */
  border-radius: 8px;
  transition: all 0.3s ease;
}

.function-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.function-icon {
  /* width: 80px;
  height: 80px; */
  /* margin-bottom: 20px; */
  /* display: flex;
  align-items: center;
  justify-content: center; */
  /* background: #1B5AFF; */
  /* border-radius: 50%; */
}

.function-icon img {
  width: 88px;
  height: 88px;
  /* filter: brightness(0) invert(1); */
}

.function-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.function-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

/* 评价工作流程 */
.workflow-steps {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-top: 40px;
  cursor: pointer;
}

.workflow-steps::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 4px;
  background: repeating-linear-gradient(
    to right,
    #1B5AFF 0px,
    #1B5AFF 4px,
    transparent 4px,
    transparent 8px
  );
  transform: translateY(-50%);
  z-index: 1;
}

.workflow-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  z-index: 2;
  background: #fff;
  padding: 0 20px;
  transition: all 0.3s ease;
}
.workflow-step:hover {
  transform: translateY(-5px);
  /* box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1); */
}

.step-icon {
  /* width: 100px;
  height: 100px; */
  /* margin-bottom: 15px; */
  /* display: flex;
  align-items: center;
  justify-content: center; */
  /* background: #1B5AFF; */
  /* border-radius: 50%; */
}

.step-icon img {
  width: 100px;
  height: 100px;
  /* filter: brightness(0) invert(1); */
}

.step-number {
  font-weight: 500;
  font-size: 18px;
  color: #1B5AFF;
  margin-bottom: 5px;
}

.step-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  /* margin-bottom: 5px; */
}

.step-desc {
  font-size: 14px;
  color: #666;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .banner-content {
    flex-direction: column;
    text-align: center;
  }

  .banner-text {
    padding-right: 0;
    margin-bottom: 30px;
  }

  .banner-image {
    flex: 0 0 250px;
  }

  .content-item {
    padding: 20px;
  }

  .bottom-links {
    flex-direction: column;
    gap: 20px;
  }

  .link-item {
    justify-content: center;
  }
}
</style>